import { each, equals2, filterL, go } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
import { Point } from "./Point.js";
export class CommandQ {
  constructor({ svg_el, control_point, target_point }) {
    this._observer_set = new Set();
    this._svg_el = svg_el;
    this._target_point = target_point;
    this._target_point_vo = {
      x: 0,
      y: 0,
    };
    this._target_point_is_show = false;
    this._target_point_is_selected = false;
    this._control_point = control_point;
    this._control_point_vo = {
      x: 0,
      y: 0,
    };
    this._control_point_is_show = false;
    this._control_point_is_selected = false;
    this._prev_command = null;
    this._initial_point_observer_set = new Set();
    this._initial_point_vo = {
      x: 0,
      y: 0,
    };
    this._initial_point_subscription = null;
    this._initial_point_is_show_observer_set = new Set();
    this._initial_point_is_show = false;
    this._initial_point_is_show_subscription = null;
    this._initial_point_is_selected_observer_set = new Set();
    this._initial_point_is_selected = false;
    this._initial_point_is_selected_subscription = null;
    this._current_point_vo = {
      x: 0,
      y: 0,
    };
    this._current_point_subscription = null;
    this._current_point_is_show = false;
    this._current_point_is_show_subscription = null;
    this._current_point_is_selected = false;
    this._current_point_is_selected_subscription = null;
    target_point.subscribePoint((vo) => this._observeTargetPoint(vo));
    target_point.subscribeIsShow((is_show) =>
      this._observeTargetPointIsShow(is_show)
    );
    target_point.subscribeIsSelected((is_selected) =>
      this._observeTargetPointIsSelected(is_selected)
    );
    control_point.subscribePoint((vo) => this._observeControlPoint(vo));
    control_point.subscribeIsShow((is_show) =>
      this._observeControlPointIsShow(is_show)
    );
    control_point.subscribeIsSelected((is_selected) =>
      this._observeControlPointIsSelected(is_selected)
    );
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._toVO());
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  subscribeInitialPoint(observer) {
    if (this._initial_point_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._initial_point_vo);
    this._initial_point_observer_set.add(observer);
    return () => {
      this._initial_point_observer_set.delete(observer);
    };
  }
  subscribeInitialPointIsShow(observer) {
    if (this._initial_point_is_show_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._initial_point_is_show);
    this._initial_point_is_show_observer_set.add(observer);
    return () => {
      this._initial_point_is_show_observer_set.delete(observer);
    };
  }
  subscribeInitialPointIsSelected(observer) {
    if (this._initial_point_is_selected_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._initial_point_is_selected);
    this._initial_point_is_selected_observer_set.add(observer);
    return () => {
      this._initial_point_is_selected_observer_set.delete(observer);
    };
  }
  subscribeTargetPoint(observer) {
    return this._target_point.subscribePoint(observer);
  }
  subscribeTargetPointIsShow(observer) {
    return this._target_point.subscribeIsShow(observer);
  }
  subscribeTargetPointIsSelected(observer) {
    return this._target_point.subscribeIsSelected(observer);
  }
  setPrevCommand(prev_command) {
    this._initial_point_subscription?.();
    this._initial_point_subscription = null;
    this._initial_point_is_show_subscription?.();
    this._initial_point_is_show_subscription = null;
    this._initial_point_is_selected_subscription?.();
    this._initial_point_is_selected_subscription = null;
    this._current_point_subscription?.();
    this._current_point_subscription = null;
    this._current_point_is_show_subscription?.();
    this._current_point_is_show_subscription = null;
    this._current_point_is_selected_subscription?.();
    this._current_point_is_selected_subscription = null;
    this._prev_command = prev_command;
    if (prev_command == null) {
      this._initial_point_vo = {
        x: 0,
        y: 0,
      };
      this._initial_point_is_show = false;
      this._initial_point_is_selected = false;
      this._current_point_vo = {
        x: 0,
        y: 0,
      };
      this._current_point_is_show = false;
      this._current_point_is_selected = false;
      this._notify(this._toVO());
      this._notifyInitialPoint(this._initial_point_vo);
      this._notifyInitialPointIsShow(this._initial_point_is_show);
      this._notifyInitialPointIsSelected(this._initial_point_is_selected);
      return;
    }
    this._current_point_subscription = prev_command.subscribeTargetPoint((vo) =>
      this._observeCurrentPoint(vo)
    );
    this._current_point_is_show_subscription =
      prev_command.subscribeTargetPointIsShow((is_show) =>
        this._observeCurrentPointIsShow(is_show)
      );
    this._current_point_is_selected_subscription =
      prev_command.subscribeTargetPointIsSelected((is_selected) =>
        this._observeCurrentPointIsSelected(is_selected)
      );
    this._initial_point_subscription = prev_command.subscribeInitialPoint(
      (vo) => this._observeInitialPoint(vo)
    );
    this._initial_point_is_show_subscription =
      prev_command.subscribeInitialPointIsShow((is_show) =>
        this._observeInitialPointIsShow(is_show)
      );
    this._initial_point_is_selected_subscription =
      prev_command.subscribeInitialPointIsSelected((is_selected) =>
        this._observeInitialPointIsSelected(is_selected)
      );
  }
  toString() {
    const prev_str = this._prev_command?.toString();
    const { x: x1, y: y1 } = this._control_point_vo;
    const { x, y } = this._target_point_vo;
    const str = `Q ${x1} ${y1} ${x} ${y}`;
    return `${prev_str ? `${prev_str} ` : ""}${str}`;
  }
  click({ point }) {
    if (equals2(point)("target")) {
      this._control_point.show();
      this._target_point_is_selected
        ? this._control_point.unselect()
        : this._control_point.select();
      this._target_point.show();
      this._target_point.select();
      return;
    }
    if (equals2(point)("control")) {
      this._control_point.show();
      this._control_point.select();
      this._target_point.show();
      this._target_point.unselect();
      this._prev_command?.showTargetPoint();
      return;
    }
    if (!this._current_point_is_selected) {
      this._control_point.unselect();
    }
    if (!this._current_point_is_show) {
      this._control_point.hide();
    }
    this._target_point.unselect();
    this._target_point.hide();
  }
  showTargetPoint() {
    this._target_point.show();
  }
  showInitialPoint() {
    this._prev_command?.showInitialPoint();
  }
  transform(matrix) {
    go(
      [
        [
          this._control_point_is_selected,
          this._control_point_vo,
          this._control_point,
        ],
        [
          this._target_point_is_selected,
          this._target_point_vo,
          this._target_point,
        ],
      ],
      filterL(([is_selected]) => is_selected),
      each(([, { x, y }, point]) => {
        const p = CommonNS.UtilNS.createSVGPoint(this._svg_el)([
          x,
          y,
        ]).matrixTransform(matrix);
        point.setPoint({
          x: p.x,
          y: p.y,
        });
      })
    );
  }
  getIsSelected() {
    return this._control_point_is_selected || this._target_point_is_selected;
  }
  getIsTargetPointSelected() {
    return this._target_point_is_selected;
  }
  getTargetPoint() {
    return this._target_point_vo;
  }
  moveTargetPoint(point) {
    this._target_point.setPoint(point);
  }
  _notify(command_q_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(command_q_vo));
    }
  }
  _notifyInitialPoint(point_vo) {
    for (const observer of this._initial_point_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(point_vo));
    }
  }
  _notifyInitialPointIsShow(is_show) {
    for (const observer of this._initial_point_is_show_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(is_show));
    }
  }
  _notifyInitialPointIsSelected(is_selected) {
    for (const observer of this._initial_point_is_selected_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(is_selected));
    }
  }
  _observeTargetPoint(point_vo) {
    this._target_point_vo = point_vo;
    this._notify(this._toVO());
  }
  _observeTargetPointIsShow(is_show) {
    this._target_point_is_show = is_show;
    this._notify(this._toVO());
    if (is_show) {
      this._control_point.show();
    }
  }
  _observeTargetPointIsSelected(is_selected) {
    this._target_point_is_selected = is_selected;
    this._notify(this._toVO());
  }
  _observeControlPoint(point_vo) {
    this._control_point_vo = point_vo;
    this._notify(this._toVO());
  }
  _observeControlPointIsShow(is_show) {
    this._control_point_is_show = is_show;
    this._notify(this._toVO());
  }
  _observeControlPointIsSelected(is_selected) {
    this._control_point_is_selected = is_selected;
    this._notify(this._toVO());
  }
  _observeCurrentPoint(point_vo) {
    this._current_point_vo = point_vo;
    this._notify(this._toVO());
  }
  _observeCurrentPointIsShow(is_show) {
    this._current_point_is_show = is_show;
    this._notify(this._toVO());
    if (is_show) {
      this._control_point.show();
    }
  }
  _observeCurrentPointIsSelected(is_selected) {
    const prev_is_selected = this._current_point_is_selected;
    this._current_point_is_selected = is_selected;
    this._notify(this._toVO());
    if (!prev_is_selected && is_selected) {
      this._control_point.select();
    } else if (prev_is_selected && is_selected) {
      this._control_point.unselect();
    }
  }
  _observeInitialPoint(point_vo) {
    this._initial_point_vo = point_vo;
    this._notifyInitialPoint(this._initial_point_vo);
  }
  _observeInitialPointIsShow(is_show) {
    this._initial_point_is_show = is_show;
    this._notifyInitialPointIsShow(this._initial_point_is_show);
  }
  _observeInitialPointIsSelected(is_selected) {
    this._initial_point_is_selected = is_selected;
    this._notifyInitialPointIsSelected(this._initial_point_is_selected);
  }
  _toVO() {
    return {
      current_point: {
        ...this._current_point_vo,
        is_show: this._current_point_is_show,
        is_selected: this._current_point_is_selected,
      },
      control_point: {
        ...this._control_point_vo,
        is_show: this._control_point_is_show,
        is_selected: this._control_point_is_selected,
      },
      target_point: {
        ...this._target_point_vo,
        is_show: this._target_point_is_show,
        is_selected: this._target_point_is_selected,
      },
    };
  }
}
